import { useEffect, useState } from 'react';

import { useRouter } from 'next/router';

import UseModal from 'hooks/use-modal';
import useWindowSize from 'hooks/use-windowSize';

import SearchPageSort from 'components/common/search/searchpagesort/SearchPageSort';
import Modal from '../../Modal/Modal';

import { MOBILE_SLIDE_UP } from '@core/constants/ModalTypes';

import SortIcon from 'assets/icons/sort-icon.svg';

import classes from './Sort.module.scss';

const Sort = () => {
	const { desktopDevice } = useWindowSize();
	const router = useRouter();

	const [searchParams, setSearchParams] = useState({});

	const [order, setOrder] = useState('');
	useEffect(() => {
		if (router.isReady) {
			if (searchParams.ordering !== router.query.ordering) {
				const { id, ...searchparams } = router.query;
				setSearchParams(searchparams);
				setOrder(router?.query?.ordering || '');
			}
		}
	}, [router.asPath]);

	const { showModal: showSortModal, destroyModal: destroySortModal, show: showSort } = UseModal();

	const ApplyModalParams = (param, value, closeHanlder) => {
		router.replace(
			{
				pathname: router.pathname,
				query: {
					...router.query,
					[param]: value
				}
			},
			undefined,
			{ shallow: true }
		);
		closeHanlder();
	};

	const sortHandler = (value) => {
		router.replace(
			{
				pathname: router.pathname,
				query: {
					...router.query,
					ordering: value
				}
			},
			undefined,
			{ shallow: true }
		);
	};

	return (
		<>
			{!desktopDevice ? (
				<>
					<Modal
						title="Sort By:"
						actions={
							<button
								className={`${classes['apply-modal']}`}
								onClick={() => ApplyModalParams('ordering', order, destroySortModal)}>
								Apply Sort
							</button>
						}
						closeHandler={destroySortModal}
						show={showSort}
						type={MOBILE_SLIDE_UP}>
						<div className={classes['mobile-sort-modal']}>
							<SearchPageSort sort={order} sortHandler={setOrder} />
						</div>
					</Modal>
					<button onClick={() => showSortModal()}>
						<SortIcon /> Sort
					</button>
				</>
			) : (
				<SearchPageSort sort={searchParams.ordering} sortHandler={sortHandler} />
			)}
		</>
	);
};

export default Sort;
